'use client';

import styled from '@emotion/styled';
import { IJumpToSectionEntry } from '../../../../contentful';
import { Color } from '../../../../styles/Color';
import { ContentWrap, Css, ArrowForwardIcon } from '../../../../ui';

interface IJumpToSectionProps {
	jumpToSection: IJumpToSectionEntry;
}

export function JumpToSection({ jumpToSection }: IJumpToSectionProps) {
	const sectionId = jumpToSection.fields.section?.id;

	if (!sectionId) {
		return null;
	}

	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();
		const target = document.getElementById(`section-${sectionId}`);
		target?.scrollIntoView({ behavior: 'smooth' });
	};

	return (
		<StyledContentWrap>
			<StyledLink href={`#section-${sectionId}`} onClick={handleClick}>
				<JumpToSectionButton>
					<ArrowIcon />
				</JumpToSectionButton>
				{jumpToSection.fields.title}
			</StyledLink>
		</StyledContentWrap>
	);
}

const StyledLink = styled.a`
	display: flex;
	align-items: center;
	text-decoration: none;
	color: ${Color.OnBackground};
	font-weight: 700;
	gap: ${Css.pxToRem(8)};
`;
const StyledContentWrap = styled(ContentWrap)`
	display: flex;
	flex-direction: row;
	align-items: center;
	border-bottom: 1px solid ${Color.Neutral3};
	padding: ${Css.pxToRem(16)} 0;
`;

const JumpToSectionButton = styled.div`
	display: flex;
	align-items: center;
	padding: ${Css.pxToRem(8)};
	border: 1px solid ${Color.BorderCard};
	border-radius: ${Css.pxToRem(8)};
	color: ${Color.OnBackground};
	transition: box-shadow 0.2s ease;

	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

const ArrowIcon = styled(ArrowForwardIcon)`
	transform: rotate(90deg);
	width: ${Css.pxToRem(24)};
	height: ${Css.pxToRem(24)};
	flex-shrink: 0;
`;
